import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DriverForm from "./driverComponents/DriverForm";

import {
  useGetDriverDetailQuery,
  useUpdateDriverMutation,
} from "store/services/driverApi";

import { useAppMeta } from "hooks";

const DriverEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Drivers", path: "/app/crm/driver/list" },
    { title: "Edit Driver" },
  ];

  // RTK Query
  const {
    data: driverDetail,
    isLoading: loadingDriverDetail,
    error,
  } = useGetDriverDetailQuery(id);

  const [updateDriver, { isLoading: updatingDriver }] =
    useUpdateDriverMutation();

  // methods
  const handleUpdateDriver = async (data) => {
    try {
      await updateDriver(data).unwrap();
      toast.success("Driver successfully updated!");
      navigate(`/app/crm/driver/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update driver!");
    }
    
  };

  useAppMeta("Edit Driver");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={updatingDriver || loadingDriverDetail}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <DriverForm
          driver={driverDetail}
          onSubmit={handleUpdateDriver}
          isBusy={updatingDriver || loadingDriverDetail}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DriverEditScreen;
